import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DashboardJefeServices from "./DashboardJefe.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDashboardJefe = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DASHBOARD_JEFE,
      payload: true,
    });
    const resp = await DashboardJefeServices.getDashboardJefe(filters);
    dispatch({
      type: actions.GET_DASHBOARD_JEFE,
      payload: resp.data,
    });
    dispatch({
      type: actions.DASHBOARD_JEFE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.DASHBOARD_JEFE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DASHBOARD_JEFE,
      payload: false,
    });
  }
};
